module.exports = __webpack_public_path__ + "img/login2.8c3044ee.jpg";